import React from 'react';
import { Loading } from '@app/components/Loading';
import { PrivateAndPublicRouteProps } from '../types';
import withTabHandler from './withTabHandler';

const PublicRoute = ({ Component }: PrivateAndPublicRouteProps) => {
  return (
    <React.Suspense fallback={<Loading fullScreen blocked />}>
      <Component />
    </React.Suspense>
  );
};
export default withTabHandler(PublicRoute);
